export default function initQuickSearch() {
//setup before functions
    var typingTimer;                //timer identifier
    var doneTypingInterval = 500;  //time in ms, 5 second for example
    var $input = $('input[name=keyword]');

//on keyup, start the countdown
    $input.on('keyup', function () {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(doneTyping, doneTypingInterval);
    });

//on keydown, clear the countdown
    $input.on('keydown', function () {
        clearTimeout(typingTimer);
    });

//user is "finished typing," do something
    function doneTyping() {
        loadInputs(
            $input.closest('[quicksearch-form]').prop('action'),
            $input.val(),
        );
    }

    $('form[quicksearch-form]').on('submit', function (e) {
        e.preventDefault();
        window.location.href = $(this).attr('submit-route') + '?keyword=' + $input.val();
    });

    function loadInputs(route, keyword) {
        $.ajax(`${route}?keyword=${keyword}`,
            {
                dataType: 'html',
                success: function (data) {
                    $('[data-quicksearch]').empty().append(data);
                },
                error: function (jqXhr) {
                    console.error(jqXhr);
                }
            }
        );
    }
}